import {countries} from 'countries-list';

let Countries = {};
let CountryCodes = {};
let CountryOptions = [];
Object.keys(countries).forEach((countryCode) => {
  const countryName = countries[countryCode].name;
  Countries[countryCode] = countryName;
  CountryCodes[countryCode] = countryCode;
  CountryOptions.push({key: countryCode, value: countryName});
});

CountryOptions.sort((countryOptionA, countryOptionB) => {
  return countryOptionA.value.localeCompare(countryOptionB.value);
});

export {
  Countries,
  CountryCodes,
  CountryOptions
};
